import { slicedToArray as _slicedToArray } from '../../_virtual/_rollupPluginBabelHelpers.js';

var useEmailMigrationData = (function (props, apollo) {
  var query = props.query,
    mutation = props.mutation;
  var useQuery = apollo.useQuery,
    useMutation = apollo.useMutation;
  var _useQuery = useQuery(query),
    loading = _useQuery.loading,
    _useQuery$data = _useQuery.data,
    _useQuery$data2 = _useQuery$data === void 0 ? {} : _useQuery$data,
    migrationData = _useQuery$data2.meEmailMigrationData;
  var meEmailMigrationData = migrationData || {};
  var id = meEmailMigrationData.id,
    doNotShowAgain = meEmailMigrationData.doNotShowAgain;
  var _useMutation = useMutation(mutation),
    _useMutation2 = _slicedToArray(_useMutation, 1),
    emailMigrationMutation = _useMutation2[0];
  var onToggleDoNotShowAgain = function onToggleDoNotShowAgain() {
    emailMigrationMutation({
      variables: {
        id: id,
        input: {
          doNotShowAgain: !doNotShowAgain
        }
      }
    });
  };
  return {
    loading: loading,
    meEmailMigrationData: meEmailMigrationData,
    onToggleDoNotShowAgain: onToggleDoNotShowAgain
  };
});

export { useEmailMigrationData as default };
